import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Input, Select, Tabs, Form, message, Checkbox } from 'antd';
import ImgUploader from '../../components/imgUploader';
import FileUploader from '../../components/fileUploader';
import NumberInput from '../../components/NumberInput';
import { CloseOutlined } from '@ant-design/icons';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import { UploadFile, RcFile } from 'antd/lib/upload/interface';
import { Link } from 'react-router-dom';
import type { TabsProps } from 'antd';
import { oneMaterial } from '../../services/materialsApi';
import { useParams, useNavigate } from "react-router-dom";
import { categoryListTreeAdmin } from '../../services/categoryApi';
import { post } from '../../services/fetch';
import { useAuth } from '../../hooks/auth';

const content = [24, 22, 20, 18, 16];
const margin = [0, 1, 2, 3, 4];
const defaultFonts = [
  "Mulish",
  "Arial",
  "Courier New",
  "Impact",
  "Georgia",
  "Tahoma",
  "Trebuchet MS",
  "Verdana",

];

const NewMaterial: React.FC = () => {
  let navigate = useNavigate();
  let { id } = useParams();
  const [form] = Form.useForm();
  const { user } = useAuth();

  useEffect(() => {
    categoryListTreeAdmin().then(result => { setCategories(result) })
    if (id) oneMaterial(+id, 0).then(result => {
      const materialData = {
        name: result.name,
        time: result.timeForLearn,
        testTime: result.testTime,
        categ: result.categoryId,
        prize0: result.prize?.split(';')[0] || '',
        prize1: result.prize?.split(';')[1] || '',
        prize2: result.prize?.split(';')[2] || '',
        questionsAmount: result.questionsAmount,
      };

      form.setFieldsValue(materialData);
      setMaterial({
        id,
        name: result.name,
        time: result.timeForLearn,
        testTime: result.testTime,
        categ: result.categoryId,
        prizes: result.prize?.split(';') || [],
        questionsAmount: result.questionsAmount,
      });
      setHtml(result.html);
      setNotifyUsers(result.notifyUsers || false);
      if (result.imgSource) setImgList([{
        uid: '0',
        name: result.imgSource,
        status: 'done',
        url: '/api/public/materials/img/' + result.imgSource,
      },])
      if (result.fileSource) setFileList([{
        uid: '0',
        name: result.fileSource,
        status: 'done',
        url: '/api/public/materials/img/' + result.fileSource,
      },])
    })
  }, [])

  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [imgList, setImgList] = useState<UploadFile[]>([]);
  const [categories, setCategories] = useState<any>([]);
  const [material, setMaterial] = useState<any>({ name: '', time: 0, categ: 0, id: 0, testTime: 600, questionsAmount: 15, prizes: [] });
  const [html, setHtml] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [notifyUsers, setNotifyUsers] = useState(false);

  const validateImage = () => {
    if (imgList.length === 0) {
      return Promise.reject(new Error('Пожалуйста, загрузите обложку!'));
    }
    return Promise.resolve();
  };

  const validateContent = () => {
    if (fileList.length === 0 && html === "") {
      return Promise.reject(new Error('Пожалуйста, добавьте презентацию или текст!'));
    }
    return Promise.resolve();
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: `Текст`,
      children:
        <SunEditor
          lang="ru"
          setContents={html}
          onChange={(data) => setHtml(data)}
          placeholder="Введите текст"
          setDefaultStyle={"font-family: Mulish; font-size: 16px;"}
          setOptions={{
            buttonList: [
              ["undo", "redo"],
              ["font", "fontSize", "formatBlock"],
              [
                "bold",
                "underline",
                "italic",
                "strike",
                "subscript",
                "superscript"
              ],
              ["fontColor", "hiliteColor"],
              ["align", "list", "lineHeight"],
              ["outdent", "indent"],
              ["table", "horizontalRule", "link"],
              ["preview", "print"],
              ["removeFormat"],
              ['image'],
              ['codeView']
            ],
            defaultTag: "div",
            minHeight: "300px",
            font: defaultFonts
          }}
        />,
    },
    {
      key: '2',
      label: `Презентация`,
      children: <FileUploader fileList={fileList} setFileList={setFileList} />,
    },
  ];

  const updateFile = async (id: string, type: string) => {
    const list = type === 'img' ? imgList : fileList;
    if (!list[0] || list[0].uid === '0') return;
    const formData = new FormData();
    formData.append('file', list[0] as RcFile);
    formData.append('type', type);
    formData.append('id', id);
    await post('/material/saveFiles', formData, false)
  }

  const onFinish = async (values: any) => {
    try {
      await validateImage();
      await validateContent();
    } catch (error: any) {
      message.error(error.message);
      return;
    }

    setIsLoading(true);
    try {
      const response: { success: boolean, id: number } = await post('/material/save', {
        'name': values.name,
        'categ': values.categ,
        'time': values.time,
        'prizes': [values.prize0, values.prize1, values.prize2].join(';'),
        'html': html,
        'id': material.id,
        'testTime': values.testTime,
        'questionsAmount': values.questionsAmount,
        'notifyUsers': notifyUsers
      });

      if (response.success) {
        const newId = response.id || material.id;
        await updateFile(String(newId), 'img');
        if (fileList.length > 0 && fileList[0].uid !== '0') {
          await updateFile(String(newId), 'file');
        }
        setIsLoading(false);
        navigate("/admin/materials/" + newId);
      }
    } catch (error) {
      setIsLoading(false);
      message.error('Произошла ошибка при сохранении');
    }
  };

  const savePrize = (position: number, value: string) => {
    const prizes = [...material.prizes];
    const numValue = parseInt(value, 10);
    if (isNaN(numValue) || numValue < 0) {
      return;
    }
    const validValue = Math.min(numValue, 1000);
    prizes[position] = String(validValue);
    if (position === 0) {
      prizes[1] = prizes[2] = String(Math.round(validValue / 2));
      form.setFieldsValue({
        prize1: String(Math.round(validValue / 2)),
        prize2: String(Math.round(validValue / 2))
      });
    }
    setMaterial({ ...material, prizes })
  }

  return (
    <Row style={{ margin: '30px 0' }}>
      <Col xs={margin[0]} sm={margin[1]} md={margin[2]} lg={margin[3]} xl={margin[4]}></Col>
      <Col xs={content[0]} sm={content[1]} md={content[2]} lg={content[3]} xl={content[4]}>
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={[16, 16]} >
            <Col span={12} style={{ fontSize: 25 }}>
              {material.id ? 'Изменение материала №' + material.id : 'Новый материал'}
            </Col>

            <Col span={24}>
              <Form.Item
                label="Название"
                name="name"
                rules={[{ required: true, message: 'Пожалуйста, введите название!' }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col>
              Обложка для обучения
            </Col>
            <Col span={24} style={{ color: '#B6B6B6', fontSize: 14 }}>
              <ImgUploader fileList={imgList} setFileList={setImgList} />
              Максимальный размер изображения 30 Мб
            </Col>

            <Col span={24}>
              <Form.Item
                label="Время для изучения, мин."
                name="time"
                rules={[
                  { required: true, message: 'Пожалуйста, введите время для изучения!' },
                  {
                    validator: (_, value) => {
                      if (!value || value <= 0) {
                        return Promise.reject(new Error('Время должно быть больше 0!'));
                      }
                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <NumberInput min={1} max={9999} />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="Время для прохождения теста, секунд."
                name="testTime"
                rules={[
                  { required: true, message: 'Пожалуйста, введите время для теста!' },
                  {
                    validator: (_, value) => {
                      if (!value || value <= 0) {
                        return Promise.reject(new Error('Время должно быть больше 0!'));
                      }
                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <NumberInput min={1} max={7200} />
              </Form.Item>
            </Col>

            <Col span={24}>
              <div>Баллов за успешное прохождение теста</div>
              <Row style={{ marginTop: 10 }}>
                <Col span={8}>
                  <Form.Item
                    label="1-е прохождение"
                    name="prize0"
                    rules={[{ required: true, message: 'Обязательно!' }]}
                  >
                    <NumberInput onChange={(value) => savePrize(0, value)} min={0} max={1000} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="2-е прохождение"
                    name="prize1"
                    rules={[{ required: true, message: 'Обязательно!' }]}
                  >
                    <NumberInput onChange={(value) => savePrize(1, value)} min={0} max={1000} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="> 2-го прохождения"
                    name="prize2"
                    rules={[{ required: true, message: 'Обязательно!' }]}
                  >
                    <NumberInput onChange={(value) => savePrize(2, value)} min={0} max={1000} />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            <Col span={24}>
              <Form.Item
                label="Количество вопросов в тесте"
                name="questionsAmount"
                rules={[
                  { required: true, message: 'Пожалуйста, введите количество вопросов!' },
                  {
                    validator: (_, value) => {
                      if (!value || value <= 0) {
                        return Promise.reject(new Error('Количество должно быть больше 0!'));
                      }
                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <NumberInput min={1} max={100} />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="Категория"
                name="categ"
                rules={[{ required: true, message: 'Пожалуйста, выберите категорию!' }]}
              >
                <Select
                  style={{ width: '100%' }}
                  placeholder='Выберите категорию'
                  options={[
                    ...categories.map((x: any) => ({ value: x.id, label: x.name }))
                  ]}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Tabs defaultActiveKey="1" items={items} />
            </Col>

            {user?.type === 'admin' && (
              <Col span={24}>
                <Form.Item>
                  <Checkbox
                    checked={notifyUsers}
                    onChange={(e) => setNotifyUsers(e.target.checked)}
                  >
                    Уведомить пользователей о новом/обновлённом материале
                  </Checkbox>
                </Form.Item>
              </Col>
            )}

            <Col span={24}>
              <Button loading={isLoading} type='primary' htmlType="submit">
                Сохранить
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
      <Col xs={margin[0]} sm={margin[1]} md={margin[2]} lg={margin[3]} xl={margin[4]}></Col>
      <Link to={'/admin/materials/' + material.id}><div style={{ position: 'absolute', right: 10, top: 30, color: '#858585', padding: '6px 8px', background: '#CECECE', borderRadius: 20 }}> <CloseOutlined /></div></Link>
    </Row>
  );
};

export default NewMaterial;
